import React from 'react';
import {  NavLink,withRouter } from 'react-router-dom'

import Subscribe from '../containers/SubscribeContainer';



const Footer = (props) => {

return (

<>
<div className="footer">
<div className="container mb-1">
<div className="row ">
<div className="col-md-6 offset-md-3">
<Subscribe />
</div>
</div>


<div className="row mb-2">
<div className="footer-widget col-lg-6 col-md-6 col-sm-6 col-12">
<div className="footer-logo">
<NavLink exact to="/" ><img src="/images/logo.png" alt=""/></NavLink>
</div>
</div>
<div className="footer-widget col-lg-6 col-md-6 col-sm-6 col-12 ">
<div className="footer-social foosocial float-md-right float-lg-right mt-3">
<a href="https://www.facebook.com/The-Organic-Forest-113438947068234" target={"_blank"}  className="facebook"><i className="fa fa-facebook"></i></a>
{/* <a href="https://twitter.com/forest_organic" target={"_blank"} className="twitter"><i className="fa fa-twitter"></i></a>                                 */}
<a href="https://www.instagram.com/the_organic_forest" target={"_blank"} className="linkedin"><i className="fa fa-instagram"></i></a>
<a href="https://wa.me/918595749256/?text=I have a few questions. Can you help?" target={"_blank"} className="linkedin"><i className="fa fa-whatsapp"></i></a>
</div>
</div>
</div>
</div>
</div>

<footer className="footer-section section  footer_main footbox">



<div className="footer-top section pt-50 pt-lg-40 pt-md-70 pt-sm-60 pt-xs-50 pb-45 pb-lg-25 pb-md-15 pb-sm-5 pb-xs-0 footboxb">
<div className="container">
<div className="row row-25">


<div className="footer-widget col-lg-4 col-md-6 col-sm-6 col-12 mb-40 mb-xs-35">
<h4 className="title titleitm"><span className="text" style={{'paddingBottom':'6px'}}>Reviews</span></h4>


<a href="https://www.google.com/search?sxsrf=ALeKk02KcVKU4tFvfXg35PeE5KYt12nAlg%3A1593517788609&source=hp&ei=3Cb7Xo3lIryprtoP_5CF2AE&q=the+organic+forest&oq=the+organic+forest&gs_lcp=CgZwc3ktYWIQAzICCAAyAggAMgYIABAWEB4yBggAEBYQHjoECCMQJzoHCAAQgwEQQzoFCAAQgwE6BAgAEEM6BwgAELEDEEM6BQgAELEDOgQIABAKUI8LWMooYKEsaABwAHgAgAGZAogBnB2SAQYwLjcuMTGYAQCgAQGqAQdnd3Mtd2l6&sclient=psy-ab&ved=0ahUKEwiNw-ytvKnqAhW8lEsFHX9IARsQ4dUDCAc&uact=5#lrd=0x390ce760088e1569:0xfad1623e69f0471f,1,,," target={"_blank"} className="twitter">                                

<img src="/images/google-icon.png" width="50%" alt=""/> 
<p><b>5.0 Star Customer Rating</b></p>
<div className="footer-social starsec">
<i class="fa fa-star" aria-hidden="true"></i>
<i class="fa fa-star" aria-hidden="true" style={{'marginLeft':'5px'}}></i>
<i class="fa fa-star" aria-hidden="true" style={{'marginLeft':'5px'}}></i>
<i class="fa fa-star" aria-hidden="true" style={{'marginLeft':'5px'}}></i>
<i class="fa fa-star" aria-hidden="true" style={{'marginLeft':'5px'}}></i>

</div>
<p><b>READ REVIEWS</b></p>

</a>
</div>

<div className="footer-widget col-lg-4 col-md-6 col-sm-6 col-12 mb-40 mb-xs-35">
<h4 className="title titleitm"><span className="text" style={{'paddingBottom':'6px'}}>Company</span></h4>
<ul className="ft-menu">
<li><NavLink exact to="/our-story" >Our Story</NavLink></li>
<li><NavLink exact to="/privacy-policy" >Privacy Policy</NavLink></li>
<li><NavLink exact to="/terms-conditions" >Terms and Conditions</NavLink></li>
<li><NavLink exact to="/blog" >Our Blog</NavLink></li>
<li><NavLink exact to="/faq" >FAQs</NavLink></li>
<li><NavLink exact to="/contactus" >Contact</NavLink></li>


</ul>
</div>

<div className="footer-widget col-lg-4 col-md-6 col-sm-6 col-12 mb-40 mb-xs-35 float-md-right float-lg-right ">
<h4 className="title titleitm"><span className="text" style={{'paddingBottom':'6px'}}></span></h4>

<img src="/images/freeshipping.png" width="95%" alt="freeshipping"/> <br/>
<img src="/images/logoicons.png" width="95%" alt="logoicons"/> 

</div>

</div>
</div>
</div>

<div className="footer-bottom section">
<div className="ft-border pb-20 pt-xs-20 pb-xs-20" >

<div className="container">

<div className="row row-25 mt-4 mb-4">
<div className="col-md-6">

<p className="txtcen">Copyright &copy; 2020 <a href="/">The Organic Forest</a>. All rights reserved.</p>

</div>
<div className="col-lg-6 col-md-6 col-sm-4 col-12 txtcen">
<div className="footer-logo logo text-right">                               

</div>
</div>
</div>


<div className="row row-25">
<div className="col-md-12">

<p className="txtcen" style={{'color':'#0c483c'}}>Want to keep your hair fresh and strong? Buy a hair care product, Shampoo, Conditioner, Oil, Mask and Serum online at The Organic Forest that is intended for your hair type and get attractive lush hair just as Nature intended it to be. Our hair care range is 100 percent natural and all products are Plant Based , Vegan , Organic,  Cruelty Free , With no harmful chemicals like SLS, Paraben, Silicones, Mineral oils etc. All the ingredients we use are Organic and of High Quality/Grade. Some Key ingredients are Moroccan Argan Oil, Australian Tea Tree Oil, Apple Cider Vinegar, Coconut Oil. Our Shampoos efficiently remove unwanted build-up on the hair and scalp like muck, dandruff, oil, pollutants and other dead skin-particles. Check out the range on The Organic Forest and buy a hair care product that is favourable for your hair even for the most erratic weather conditions. Accomplish your hair, especially locks that are already uncontrollable with the best hair shampoos and you don't have to look back ever.</p>
<p className="txtcen" style={{'color':'#0c483c'}}><b>What are the different hair care solutions for various hair problems?</b></p>
<p className="txtcen" style={{'color':'#0c483c'}}>Choosing a hair care product from the plenty of options at your end can be a tedious task. Choosing  the right kind of hair shampoos with their luxurious formula strengthen weak hair, satiate brittle strands and are the solution for treating and saving processed hair. Your pick of hair care product will depend on your hair and scalp type and the concern you’d like to address. Finding the product that hits the right balance of oily and dry is the first step to luminous, beautiful hair.</p>
<p className="txtcen" style={{'color':'#0c483c'}}>Everybody dreams of clean, strong and shiny hair. When you preserve your hair well and opt for a specific hairstyle, you can entirely redefine your looks with ease. At The Organic Forest we bring you a wide collection of the hair care products with superior-quality formulations. You can cleanse your hair in the mildest of ways. You can choose exceptional formulations to take care of dry and damaged hair, or severe hair fall. You can keep your scalp free of flaky & Itchy skin with anti-dandruff products.</p>
<p className="txtcen" style={{'color':'#0c483c'}}>Here is a look at some of the types of hair care product that you can pick up at The Organic Forest: Opt for the Freshness of Natural, Plant Based, Vegan Shampoos which contain Organic ingredients. Choose an organic shampoo with extracts from the Moroccan Argan Oil and other plant-based ingredients which would help control hair fall.Treat an itchy scalp and dandruff with cleansers which do not dry the scalp, such as a Rosemary, Tea Tree & Apple Cider Vinegar Shampoo.</p>
<p className="txtcen" style={{'color':'#0c483c'}}>Tags : <a href="https://www.theorganicforest.com/product/anti-dandruff-shampoo" target="_blank" rel="noopener noreferrer" > Shampoos </a> | <a href="https://www.theorganicforest.com/product/anti-dandruff-conditioner" target="_blank" rel="noopener noreferrer" > Conditioner </a> | <a href="https://www.theorganicforest.com/product/anti-hairfall-oil" target="_blank" rel="noopener noreferrer"> Oil</a> | <a href="https://www.theorganicforest.com/product/anti-hairfall-mask" target="_blank" rel="noopener noreferrer" >Mask</a> | <a href="https://www.theorganicforest.com/product/anti-hairfall-shampoo" target="_blank" rel="noopener noreferrer">Argan Shampoo</a> | <a href="https://www.theorganicforest.com/solution/anti-hairfall" target="_blank" rel="noopener noreferrer"> Anti Hair Fall </a> | <a href="https://www.theorganicforest.com/solution/anti-dandruff" target="_blank" rel="noopener noreferrer" >Anti Dandruff </a> | <a href="https://www.theorganicforest.com/product/anti-dandruff-oil" target="_blank" rel="noopener noreferrer" > Hair growth oil </a> | <a href="https://www.theorganicforest.com/product/anti-dandruff-oil" target="_blank" rel="noopener noreferrer" >Tea tree oil</a> | <a href="https://www.theorganicforest.com/product/anti-hairfall-oil" target="_blank" rel="noopener noreferrer" >Onion Oil</a> | <a href="https://www.theorganicforest.com/product/anti-hairfall-mask" target="_blank" rel="noopener noreferrer" >Argan Hair Mask</a> | <a href="https://www.theorganicforest.com/product/anti-dandruff-shampoo" target="_blank" rel="noopener noreferrer" >Vegan Shampoo</a> | <a href="https://www.theorganicforest.com/shop" target="_blank" rel="noopener noreferrer" >Vegan Products</a> | <a href="https://www.theorganicforest.com/product/anti-dandruff-shampoo" target="_blank" rel="noopener noreferrer" >Apple Cider Vinegar for Dandruff</a> | <a href="https://www.theorganicforest.com/shop" target="_blank" rel="noopener noreferrer"  >Organic Products</a> | <a href="https://www.theorganicforest.com/solution/anti-hairfall" target="_blank" rel="noopener noreferrer" >Hair Care Products</a> | <a href="https://www.theorganicforest.com/product/anti-dandruff-shampoo" target="_blank" rel="noopener noreferrer"  >Chemical Free Shampoo
</a> | <a href="https://www.theorganicforest.com/shop" target="_blank" rel="noopener noreferrer">SLS Free</a> | <a href="https://www.theorganicforest.com/shop" target="_blank" rel="noopener noreferrer">Paraben Free</a>

</p>

</div> 

</div>
</div>


</div>
</div>

<a href="https://wa.me/918595749256/?text=I have a few questions. Can you help?"
        class="whatsapp_float"
        target="_blank"
        rel="noopener noreferrer"
      >
     <i class="fa fa-whatsapp whatsapp-icon"></i>
      </a>


</footer>

</>



)


}

export default withRouter(Footer)





